// extracted by mini-css-extract-plugin
export var modal = "_kb-0";